import * as React from 'react';

import LoadingIndicator from 'af-components/LoadingIndicator';

import styles from './styles.module.scss';

const Loading: React.FC = () => {

	return (
		<div className={styles['loading-container']} >
			<LoadingIndicator color="orange" />
		</div >
	);

};

export default React.memo(Loading);
